export default {"src":"/_next/static/media/calendar_24.b056d0c3.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};